<template>
    <div class="task" v-cloak> 
        <div class="bgBox"><img src="./../../../assets/home/other-bg-op.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <i @click="backWarning"><img src="./../../../assets/home/back.jpg" alt=""> </i>
            <span>快速赚钱</span>
        </div>
        <div class="taskBox">
            <p class="taskTitle">下载App试玩<span class="out"> + <span class="in" ref="price">0.88</span> 元 </span></p>
            <keep-alive><p class="taskText">任务倒计时 <span>当天有效</span></p></keep-alive>
        </div>
        <div class="stepBox">
            <div class="stepOneBox">
                <p class="stepOneTitle">① 下载应用：<span style="color:red">{{keyword}}</span></p>
                <p class="stepOneText">若已删除，请重新下载，若已下载，请点击开始试玩，打开应用</p>
            </div>
            <div class="appBox">
                <div class="imgBox"><img src="./../../../assets/home/userlogo.png" alt="" ref="src"></div>
                <div class="appName" ref="title"></div>
                <div class="download active" @click="openAppStore"
                    v-clipboard:copy="keyword"
                    >下载应用</div>
            </div>
            <div class="stepTwoBox">
                <p class="stepTwoTitle">② 点击“开始试玩” 体验 {{playtime}} 分钟</p>
                <p class="stepTwoText">{{content}}</p>
            </div>
            <div class="playBox">
                <button class="startPlay undisabled" style="display:block;margin-top:-10px" ref="play" @click="playApp">开始试玩</button>
                <button disabled="disabled" class="startPlay " style="display:none;margin-top:-10px" ref="unplay">开始试玩</button>
            </div>
            <div class="stepThereBox" style="margin-top:-30px">
                <p class="stepThereTitle">③试玩结束回本页领奖</p>
            </div>
            <div class="getRewardBox" style="margin-top:-30px">
                <div class="getReward undisabled" ref="reward" @click="getReward">领取奖励</div>
                <button disabled="disabled" class="getReward" ref="unreward">领取奖励</button>
            </div>
        </div>

        <div class="erwmshow" ref="erwmshow">
            <div class="mask"></div>
            <div class="share" ref="share">
                <p class="title">首次打开应用时请允许</p>
                <p class="titlef">无线网络与蜂窝移动网络</p>
                <img src="./../../../assets/home/yx.png" alt="">
                <div class="paths">
                    <button class="openbutton" @click="playThisApp">打开应用</button>
                </div>
            </div>
            <div class="closex" @click="closex"><img src="./../../../assets/newtask/closex.png" alt=""></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {Toast} from 'mint-ui';
import { setTimeout } from 'timers';

let is_run = false;

export default {
    data(){
        return {
            timerTask:null,
            minutes:null,
            seconds:null,
            time : null,
            playtime :3,
            rank: null,
            keyword : "赚钱APP",
            appurl:'',
            content: "打开应用时请允许使用无线局域网与蜂窝移动网络",
            download : true,
            play:false,
            reward:false,
            isclick:false,
            isstartclick:false,
        }
    },
    methods: {
        num(n) {
            return n < 10 ? '0' + n : '' + n
        },
        closex(){
            this.$refs.erwmshow.style.display = "none"
        },
        back_off(){
            let _this = this
            let continueTaskID = _this.$route.query.continueTaskID
            let indexTaskID = _this.$route.query.indexTaskID
            let task_id = continueTaskID || indexTaskID

            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }       
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }
            setupWebViewJavascriptBridge(function(bridge) { 
            bridge.callHandler('gotUserDeviceInfo', function(response) {
                //获取手机的一系列参数，重新赋值
                let IDFA = response.IDFA
                let WIFIMac = response.WIFIMac
                let openUDID = response.openUDID
                let IP = response.ip
                let Device = response.phoneType
                let OS = response.iOSVersison
                let APPVersison = response.appVersion
                bridge.callHandler('encrypt', {    //加密获取到的数据 
                    idfa : IDFA,
                    WIFIMac : WIFIMac,
                    open_udid : openUDID,
                    ip : IP,
                    device : Device,
                    os : OS,
                    token : localStorage.getItem("UserToken"),
                    appversion : APPVersison,
                    request_time : Date.parse(new Date())
                }, function(response) {        //获取到加密后的dataReq和dataSign
                    let userInfoCode = response.dataReq
                    let userInfoSign = response.dataSign
                    
                    axios.post("/api/index/user_info", {//发送给后端加密后code和MD5值
                            code : userInfoCode,
                            dataSign : userInfoSign
                    }).then(res=>{    
                    //同时获取到后端返回的加密后的res，再调用iOS端的decrpt函数解密
                        bridge.callHandler('decrpt', {
                            dataReq : res.data.dataReq,
                            dataSign : res.data.dataSign,
                        }, function(response) { 
                            localStorage.setItem("UserToken", response.info.data.token)
                            let UID = response.info.data.id     //解密后拿到uid
                            bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                                uid : UID, 
                                idfa : IDFA, 
                                udid : openUDID,
                                ip : IP,
                                device : Device, 
                                os : OS,
                                task_id : task_id,
                                token : localStorage.getItem("UserToken"),
                                request_time : Date.parse(new Date())
                                },function(response) {               //获取到加密后的数据
                                let TaskCode = response.dataReq
                                let TaskSign = response.dataSign
                                axios.post("/api/task/abandontaskhighback", {   //发送请求给后端传加密后的数据
                                    code : TaskCode,
                                    dataSign : TaskSign
                                }).then(res=>{
                                        _this.$router.push({path:"/home/makemoney"})
                                    
                                    })
                                })
                            })
                        })
                    })
                })
            })
        },
        timercheckactive () {

            let _this = this
            setInterval(function () {
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }       
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                            
            setupWebViewJavascriptBridge(function(bridge) {  
                bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            token : localStorage.getItem("UserToken"),
                            task_id : _this.$route.query.continueTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/checkisactivehighback", {
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{
                                bridge.callHandler('decrpt', {
                                    dataReq : res.data.dataReq,
                                    dataSign : res.data.dataSign,
                                }, function(response) {  
                                    console.log("定时检测" + JSON.stringify(response))
                                    console.log("定时检测" + response)
                                    if(response.info.data.status == 1){
                                        console.log(_this.$refs.unreward.style);
                                        console.log(typeof(_this.$refs.unreward.style));
                                        if(typeof(_this.$refs.unreward.style)!='undefined'){
                                            _this.$refs.unreward.style.display = "none"
                                            _this.$refs.reward.style.display = "block"
                                            _this.isclick = false;
                                            localStorage.removeItem("Date")
                                        }
                                    }
                                })
                            })
                    })

                    }) 

            }, 30000)
        },
        timer () {
            let _this = this
            _this.seconds = 59
            if(_this.minutes>=0){
            _this.minutes -= 1 
            }else{
            _this.minutes = 0
            }
            
            _this.$route.query.continueMinute -= 1
            _this.time = setInterval(function () {
                 if (_this.seconds === 0 && _this.minutes === 0) {
                    _this.seconds = 0
                    _this.minutes = _this.$route.query.continueMinute - parseInt((Date.parse(new Date()) - localStorage.getItem("TaskTime")) / 1000 / 60)
                } else if (_this.minutes < 0) {
                    _this.seconds = 0
                    _this.minutes = 0
                    clearInterval(_this.time) 
                    alert("任务时间到，自动关闭！")
                    _this.back_off()
                    
                } else {
                    if(_this.minutes >=0){

                        _this.seconds = 59 - (Date.parse(new Date()) - localStorage.getItem("TaskTime")) / 1000 % 60

                        _this.minutes = _this.$route.query.continueMinute - parseInt((Date.parse(new Date()) - localStorage.getItem("TaskTime")) / 1000 / 60)
                    }
                }
            }, 1000)
            
        },
        backWarning(){
            let _this = this
            if(confirm("是否放弃任务？")){
                _this.back_off()
            }
        },
        openAppStore(){ //打开appstore
            console.log(this.keyword)
            console.log(this.appurl)
            if(this.keyword == ''){
                this.$bridge.callhandler('dakaizhidingdewangzhi', {
                    url: this.appurl
                    },(data) => {
                    //alert(data)
                })
            }else{

                //this.$refs.unplay.style.display = "none"
                //this.$refs.play.style.display = "block"
                this.$bridge.callhandler('openLoApplic', {
                    cn: "LSApplicationWorkspace",
                    mn: "openApplicationWithBundleID:",
                    bdid: "com.apple.AppStore"
                    },(data) => {
                    alert(data)
                })

            }
        },
        
        playApp(){

            let _this = this
            _this.$refs.erwmshow.style.display = "block"
        },
        playThisApp(){
            let _this = this
            _this.$refs.erwmshow.style.display = "none"
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }       
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)                  
            }                                                                                                    
            setupWebViewJavascriptBridge(function(bridge) {                                                  
                bridge.callHandler('openLoApplic', {
                    cn: "LSApplicationWorkspace",
                    mn: "openApplicationWithBundleID:",
                    bdid: _this.$route.query.continueBundleID
                }, function(response) {
                    if(response.info === "notOpen") {
                        Toast("应用尚未安装完成，请耐心等待") 
                    }else{
                        _this.isclick = true;
                
                        if(localStorage.getItem("Date")=='false'){
                console.log(4444444444)
                            localStorage.setItem("Date", Date.parse(new Date()))
                        }
                        if(localStorage.getItem("Date")){}else{

                console.log(4444444453222222244)
                            localStorage.setItem("Date", Date.parse(new Date()))
                        }
                        _this.timercheckactive();
                        bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                            uid : localStorage.getItem("UID"),
                            idfa : localStorage.getItem("IDFA"), 
                            udid : localStorage.getItem("openUDID"),
                            ip : localStorage.getItem("ip"),
                            token : localStorage.getItem("UserToken"),
                            device : localStorage.getItem("phoneType"), 
                            os : localStorage.getItem("iOSVersison"),
                            task_id : _this.$route.query.continueTaskID,
                            request_time : Date.parse(new Date())
                            },function(response) {               //获取到加密后的数据
                            let TaskCode = response.dataReq
                            let TaskSign = response.dataSign
                            axios.post("/api/task/openapphighback", {
                                code : TaskCode,
                                dataSign : TaskSign
                            }).then(res=>{
                                console.log("试玩游戏返回" + JSON.stringify(res.data))
                            })
                        })

                        _this.isstartclick = true;
                    }                 
                })
            })
        },
        getReward(){
            setTimeout(function() { 
                    is_run = false;
            }, 15000) 
            console.log(is_run)
            if(is_run){
                return !is_run
            }else{
            }
            let toasta = Toast({
                message: '领取中',
                iconClass: 'fa fa-spinner fa-spin',
                duration: 15000

                });
            let _this = this;
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) { 

                is_run = true;
                //判断是否在充电状态
                bridge.callHandler('checkDeviceChargeState', function(response) { 
                    console.log(response)
                    //if(response.chargeState !=='未充电'){
                     //   alert('充电状态无法领取奖励')
                   // }else{
                   let chargeState = response.chargeState;

                bridge.callHandler('gotUserDeviceInfo', function(response) {
                    //获取到设备信息
                    localStorage.setItem("IDFA",response.IDFA)
                    localStorage.setItem("openUDID",response.openUDID)
                    localStorage.setItem("ip",response.ip)
                    localStorage.setItem("phoneType",response.phoneType)
                    localStorage.setItem("iOSVersison",response.iOSVersison)
                    localStorage.setItem("appVersion",response.appVersion)
                    bridge.callHandler('encrypt', {
                        idfa : response.IDFA,
                        open_udid : response.openUDID,
                        ip : response.ip,
                        chagstatus:chargeState,
                        device : response.phoneType,
                        os : response.iOSVersison,
                        token : localStorage.getItem("UserToken"),
                        appversion : response.appVersion,
                        request_time : Date.parse(new Date())
                    }, function(response) {        //加密获取到的数据 
                        let userInfoCode = response.dataReq
                        let userInfoSign = response.dataSign
                        axios.post("/api/index/user_info", {      
                            code : userInfoCode,
                            dataSign : userInfoSign,
                        }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                                bridge.callHandler('decrpt', {
                                dataReq : res.data.dataReq,
                                dataSign : res.data.dataSign,
                                }, function(response) { 
                            localStorage.setItem("UserToken", response.info.data.token) 
                                // ios解密   赋值   渲染
                                bridge.callHandler('encrypt', {     //调用iOS端的encrypt函数将需要加密的全体加密
                                    uid : localStorage.getItem("UID"),
                                    idfa : localStorage.getItem("IDFA"), 
                                    udid : localStorage.getItem("openUDID"),
                                    ip : localStorage.getItem("ip"),
                                    device : localStorage.getItem("phoneType"), 
                                    os : localStorage.getItem("iOSVersison"),
                                    token : localStorage.getItem("UserToken"),
                                    task_id : _this.$route.query.continueTaskID,
                                    UserTaskid:_this.$route.query.continueUserTaskid,
                                    request_time : Date.parse(new Date())
                                    },function(response) {               //获取到加密后的数据
                                    let TaskCode = response.dataReq
                                    let TaskSign = response.dataSign
                                    axios.post("/api/task/activehighback", {
                                        code : TaskCode,
                                        dataSign : TaskSign
                                    }).then(res=>{
                                        if(res.data.msg == '页面超时，请返回首页'){
                                            alert(res.data.msg);
                                            _this.$router.push({path:"/home"})
                                            return;
                                        }
                                        is_run = false;
                                        console.log("领奖" + res.data.status)
                                        if(res.data.status === 0){
                                            alert(res.data.msg)
                                            toasta.close();
                                        }else if(res.data.status === 1){
                                            alert(res.data.msg)
                                            toasta.close();
                                            _this.$router.push({path:'/home/makemoney'})

                                        }
                                    })
                                })
                            })
                        })
                    })
                })
                //}
                })
                
            })
        }
    },
    watch: {
      second: {
        handler (newVal) {
          this.num(newVal)
        }
      },
      minute: {
        handler (newVal) {
          this.num(newVal)
        }
      },
    },
    computed:{
        second : function(){
            return this.num(this.seconds)
        },
        minute : function(){
            return this.num(this.minutes)
        },
    },
    mounted(){
        let timer3  =  setInterval(()=>{
            let _this =this
                console.log(localStorage.getItem("Date"))
            if(localStorage.getItem("Date")){
                // if(Date.parse(new Date()) - localStorage.getItem("Date") > 2000){
                if(Date.parse(new Date()) - localStorage.getItem("Date") > (_this.$route.query.continuePlaytime * 60 * 1000)){
                    if(typeof(_this.$refs.unreward.style)!='undefined'){
                        _this.$refs.unreward.style.display = "none"
                    }
                    _this.$refs.reward.style.display = "block"
                    localStorage.removeItem("Date")
                    clearInterval(timer3)
                }
            }
        },1000)

        
            function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }       
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                      
            let _this =this                
            setupWebViewJavascriptBridge(function(bridge) {
               
                bridge.registerHandler('EnterForeground', function(data, responseCallback){
                console.log(Date.parse(new Date()) - localStorage.getItem("Date") <= (_this.$route.query.continuePlaytime * 60 * 1000))
                    if(Date.parse(new Date()) - localStorage.getItem("Date") <= (_this.$route.query.continuePlaytime * 60 * 1000)-3){
            if(localStorage.getItem("Date")){
                        setTimeout(function(){ 
                            if(_this.isclick){
                                let tast3 = Toast("激活时间未到，系统将于3秒后跳转到app") 
                            }else{
                            //暂时不起作用
                                //Toast("app下载完成，系统将于3秒后跳转到app") 
                            }
                         }, 5000);
                        setTimeout(function(){ 
                        //如果没有到达激活时间则自动跳到对应app
                        bridge.callHandler('openLoApplic', {
                                cn: "LSApplicationWorkspace",
                                mn: "openApplicationWithBundleID:",
                                bdid: _this.$route.query.continueBundleID
                            }, function(response) {
                                if(response.info === "notOpen") {
                                    //Toast("应用尚未安装完成，请耐心等待") 
                                }else{
                                    if(!_this.isclick){
                                    }
                                }                 
                            })


                         }, 8000);
                    }
                    }
                })
            })


        if(this.$route.query.continueMinute){
            this.minutes = this.$route.query.continueMinute
            this.seconds = this.$route.query.continueSecond
            localStorage.setItem("TaskTime", Date.parse(new Date()))
            this.playtime = this.$route.query.continuePlaytime
            this.keyword = this.$route.query.continueKeyword
            this.appurl = this.$route.query.continueAppurl
            this.content = this.$route.query.continueContent
            this.rank = this.$route.query.continueRank
            this.$refs.src.src = this.$route.query.continueSrc;
            this.$refs.title.innerHTML = this.$route.query.continueTitle;
            this.$refs.price.innerHTML = this.$route.query.continuePrice;
        } 
        this.timer()
        if(this.minutes === 0 && this.seconds === 0){
            alert("时间到，任务自动关闭！")
            this.back_off()
        }
        localStorage.setItem("Date", false)

    },
    beforeDestroy() {
        if(this.time) {
            clearInterval(this.time); 
        }
    }
}
</script>

<style lang="scss" scoped>
    .bgBox{
        width:100%;
        height:2.06rem;
        position: absolute;
        right:0;
        top:.60rem;
        z-index: -1;
        img{
            border-radius: 0 0 .30rem .30rem;
        }
    }
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .taskBox{
        width:100%;
        height:1.30rem;
        .taskTitle{
            font-size: .24rem;
            padding:.40rem 0 0 5%;
            .out{
                font-size: .12rem;
                .in{
                    font-size: .24rem;
                }
            }
        }
        .taskText{
            font-size:.14rem;
            color:#B27010 ;
            padding:.08rem 0 0 5%;
        }
    }
    
    .stepBox{
        width:100%;
        background:#fff;
        .stepOneBox,.stepTwoBox,.stepThereBox{
            width:90%;
            min-height:1rem;
            margin-left: 5%;
            .stepOneTitle,.stepTwoTitle,.stepThereTitle{
                font-size: .16rem;
                padding-top:0.2rem;
            }
            .stepOneText,.stepTwoText{
                font-size: .13rem;
                padding-top:0.1rem;
            }
        }
        
        .appBox,.playBox,.getRewardBox{
            width:90%;
            height:0.7rem;
            margin-left: 5%;
            display:flex;
            align-items: center;
            position: relative;
            .imgBox{
                width:.56rem;
                height:.56rem;
                border-radius: .10rem;
            }
            .appName{
                margin-left:.10rem;
                font-size: .16rem;
            }
            .download,.startPlay,.getReward{
                width:1.1rem;
                height:0.4rem;
                font-size: .16rem;
                line-height: 0.4rem;
                text-align: center;
                border-radius: .18rem;
                background:#D8D8D8;
                color:#fff;
                position:absolute;
                right:0;
            }
            .active{
                color:#000;
                background:#FFDF42;
            }
            .undisabled{
                display:none;
                color:#000;
                background:#FFDF42;
            }
        }
        .appBox{
            height:0.7rem;
        }
    }
    .erwmshow{
        display:none;
        .mask{
            position:fixed;
            background: rgba(0,0,0,0.71);
            height:100%;
            width:100%;
            z-index: 1;
            top:0;
        }
        .share{
            width: 70%;
            height: 55%;
            background: #fff;
            position: fixed;
            bottom: 28%;
            border-radius: 20px;
            left: 15%;
            z-index: 2;
            img{
                width: 90%;
                height: auto;
                margin-left: 5.5%;
            }
            .title{
                width:100%;
                text-align: center;
                font-size: .14rem;
                color:#4A4A4A;
                margin-top:.2rem;
            }
            .titlef{
                width:100%;
                text-align: center;
                font-size: .18rem;
                font-weight: bold;
                color:#4A4A4A;
                margin-top:.1rem;
            }
            .paths{
                display: flex;
                justify-content: center;
                .openbutton{
                        width: 80%;
                        height: 74%;
                        border-radius: 20px;
                        background: #FFDF42;
                        font-size: .18rem;
                        line-height: .40rem;
                        color: #000;
                        display: inline-block;
                        text-align: center;
                        margin: .2rem .1rem 0 .1rem;
                }
            }
            .erwm{
                margin: .2rem .1rem 0 0.3rem;
                justify-content: left;
            }
        }
        .closex{
            position: fixed;
            bottom: 19%;
            border-radius: 40px;
            left: 44%;
            z-index: 2;
            width: 11%;
        }

    }
</style>

